import React from 'react';
import { State } from '../store';
import { useMutableState } from './useMutableState';

export const useAction = <Args extends unknown[], Return>(
  actionFn: (_: State, ...args: Args) => Return,
  deps: unknown[] = [],
): ((...args: Args) => Return) => React.useCallback(actionFn.bind(null, useMutableState()), deps);
